import React, { createContext } from 'react';
import { ApiState, ChildrenProps } from '../../../types';
import { useChannelsGetAll } from '../hooks/api/channels-get-all';
import { useDevicesGetAll } from '../hooks/api/devices-get-all';
import { useGroups } from '../hooks/groups/use-groups';

const initialState: ApiState = {
  groups: [],
  dashboardLoading: false,
  channelsLoading: false,
  devicesLoading: false,
  favouriteGroup: undefined,
  refetchChannels: async () => Promise.resolve({} as any),
  refetchDevices: async () => Promise.resolve({} as any),
};

export const ApiContext = createContext(initialState);

const ApiContextProvider: React.FC<ChildrenProps> = ({ children }) => {
  const devicesGetAll = useDevicesGetAll();
  const channelsGetAll = useChannelsGetAll();
  const groups = useGroups();

  const values: ApiState = {
    ...devicesGetAll,
    ...channelsGetAll,
    ...groups,
  };

  return <ApiContext.Provider value={values}>{children}</ApiContext.Provider>;
};

export default ApiContextProvider;
